<template>
<div class="modal fade" id="modalPlanType" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Plano.</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group owner-select">
            <label>Plano</label>
            <select v-model="dataPlan.plan" id="plan" name="plan" required>
              <option value="">Selecione</option>
              <option value="2">Plano até 10</option>
              <option value="3">Plano mais de 10</option>
            </select>
            <span v-if="error.plan" class="error-msg">{{error.plan}}</span>
          </div>

          <div class="form-group">
            <label>Quantos funcionários no maximo?</label>
            <input v-model="dataPlan.totalPlanEmployee" type="text" class="form-control" name="motive" required>
            <span v-if="error.totalPlanEmployee" class="error-msg">{{error.totalPlanEmployee}}</span>
          </div>

          <div class="form-group">
            <label>Valor MRR</label>
            <input v-model.lazy="dataPlan.mRRValue" v-money="money" type="text" class="form-control" id="value" name="value" required />
            <span v-if="error.mRRValue" class="error-msg">{{error.mRRValue}}</span>
          </div>

          <div class="form-group owner-select">
            <label>Tipo do Plano</label>
            <select v-model="dataPlan.duration" id="duration" name="duration" required>
              <option value="">Selecione</option>
              <option value="Mensal">Mensal</option>
              <option value="Semestral">Semestral</option>
              <option value="Bimestral">Bimestral</option>
              <option value="Trimestral">Trimestral</option>
              <option value="Anual">Anual</option>
              <option value="BiAnual">BiAnual</option>
            </select>
            <span v-if="error.duration" class="error-msg">{{error.duration}}</span>
          </div>

          <div class="form-group select-date">
            <label>Quando iniciar a contagem do plano?</label>
            <datepicker v-model="dataPlan.startAt" :language="ptBR" :format="customFormatter" placeholder="dd/mm/yyyy" />
            <i class="fa fa-calendar" aria-hidden="true"></i>
            <span v-if="error.startAt" class="error-msg">{{error.startAt}}</span>
          </div>

          <div class="form-group owner-select">
            <label>Essa venda vai para qual mês?</label>
            <select v-model="dataPlan.month">
              <option value="">Selecione</option>
              <option value="1">Janeiro</option>
              <option value="2">Fevereiro</option>
              <option value="3">Março</option>
              <option value="4">Abril</option>
              <option value="5">Maio</option>
              <option value="6">Junho</option>
              <option value="7">Julho</option>
              <option value="8">Agosto</option>
              <option value="9">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
            <span v-if="error.month" class="error-msg">{{error.month}}</span>
          </div>

          <div class="form-group">
            <label>Observações</label>
            <textarea v-model="dataPlan.notes" class="form-control" name="description"> </textarea>
          </div>

          <div class="form-group owner-select">
            <label>Enviar e-mail de boas vindas ao cliente?</label>
            <select v-model="dataPlan.sendEmail">
              <option value="false">Não</option>
              <option value="true">Sim</option>
            </select>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="sendPlan()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
          <span v-if="!loadingChange">Enviar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  UPDATE_COMPANY_PAID
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import {
  VMoney
} from 'v-money'

import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import moment from 'moment'

export default {
  name: "modalPlanType",
  props: ['dataPlanModal'],
  directives: {
    money: VMoney
  },
  components: {
    datepicker
  },
  data() {
    return {
      dataUserModal: JSON.parse(window.localStorage.getItem('mamUserMasterInfo')),
      ptBR: ptBR,
      price: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      companyId: this.$route.params.idCompany,
      contextModal: this.$route.params.context,
      error: {
        startAt: '',
        mRRValue: '',
        duration: '',
        month: '',
        totalPlanEmployee: '',
        plan: ''
      },
      dataPlan: {
        sendEmail: 'false',
        plan: '',
        totalPlanEmployee: '',
        startAt: new Date(),
        mRRValue: '',
        duration: '',
        month: '',
        notes: ''
      },
      loadingChange: false
    }
  },
  watch: {
    dataPlanModal: function (val) {
      this.dataPlan.plan = val.plan;
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    closeModal() {
      $('#modalPlanType').modal('toggle');
    },
    sendPlan() {
      this.error.plan = "";
      this.error.totalPlanEmployee = "";
      this.error.startAt = "";
      this.error.mRRValue = "";
      this.error.duration = "";
      this.error.month = "";
      this.error.notes = "";

      if (this.dataPlan.mRRValue !== 'R$ 0.00' && this.dataPlan.startAt && this.dataPlan.duration && this.dataPlan.month && this.dataPlan.totalPlanEmployee && this.dataPlan.plan && this.companyId) {
        if (!this.loadingChange) {
          this.loadingChange = true;
          let urlModal = UPDATE_COMPANY_PAID;
          urlModal += "?i=" + this.companyId;
          urlModal += "&u=" + this.dataUserModal.id;
          urlModal += "&plan=" + this.dataPlan.plan;
          urlModal += "&totalPlanEmployee=" + this.dataPlan.totalPlanEmployee;
          urlModal += "&duration=" + this.dataPlan.duration;
          urlModal += "&month=" + parseInt(this.dataPlan.month);
          urlModal += "&mRRValue=" + this.dataPlan.mRRValue.replace("R$ ", "");
          urlModal += "&startAt=" + moment(this.dataPlan.startAt).format("YYYY-MM-DD");
          urlModal += "&notes=" + this.dataPlan.notes;
          urlModal += "&sendEmail=" + this.dataPlan.sendEmail;

          UTIL_SERVICE.console("DATA SEND:", this.dataPlan);
          REQUEST_SERVICE.requestContext('GET', urlModal, this.contextModal).then((response) => {
            UTIL_SERVICE.console("RESULT UPDATE_COMPANY_PAID:", response);

            this.loadingChange = false;
            $('#modalPlanType').modal('toggle');

            ALERT_SERVICE.swal("Aviso", response.data, "success");
          }).catch((reason) => {
            this.loadingChange = false;
            $('#modalPlanType').modal('toggle');

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
        }
      } else {
        if (this.dataPlan.mRRValue === 'R$ 0.00')
          this.error.mRRValue = "Preencha um MRR.";

        if (!this.dataPlan.startAt)
          this.error.startAt = "Preencha uma data.";

        if (!this.dataPlan.duration)
          this.error.duration = "Preencha uma duração.";

        if (!this.dataPlan.month)
          this.error.month = "Preencha um mês.";

        if (!this.dataPlan.plan)
          this.error.plan = "Preencha um plano.";

        if (!this.dataPlan.totalPlanEmployee)
          this.error.totalPlanEmployee = "Preencha qtd de funcionários.";

        if (!this.companyId) {
          this.error.startAt = "CompanyID Inválido.";
          this.error.mRRValue = "CompanyID Inválido.";
          this.error.duration = "CompanyID Inválido.";
          this.error.month = "CompanyID Inválido.";
          this.error.plan = "CompanyID Inválido.";
          this.error.totalPlanEmployee = "CompanyID Inválido.";
        }
      }
    }
  },
  beforeMount() {
    let date = new Date();
    this.dataPlan.month = (date.getMonth() + 1).toString();
  }
}
</script>

<style lang="scss">
#modalPlanType {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalPlanType.vue